[
  {
    "year": 2026,
    "text": "FirstDesk simulator lab is ready for desktop, server and cloud-admin practice.",
    "pages": [
      {
        "thumbnail": {
          "source": "img/asset/community.jpg"
        },
        "content_urls": {
          "desktop": {
            "page": "https://firstdesk.nl"
          }
        }
      }
    ]
  },
  {
    "year": 2026,
    "text": "Students can use measurable actions to update simulator state for ticket evaluation.",
    "pages": [
      {
        "thumbnail": {
          "source": "img/asset/server.jpg"
        },
        "content_urls": {
          "desktop": {
            "page": "https://firstdesk.nl"
          }
        }
      }
    ]
  }
]
